import React from 'react';

import { UserContext } from '../UserProvider';
import { DataContext } from '../DataProvider';

import { updateLessonCompleteEndpoint } from '../../utils';

import styled from 'styled-components';
import quizIcon from '../../../public/quiz-icon.png';
import trainingIcon from '../../../public/training_icon.png';

const ENDPOINT = process.env.REACT_APP_API_URL;

function Lesson({ sectionLookup, item }) {
  const {
    selectedCourse,
    setSelectedVideoId,
    setSelectedQuizId,
    setApiWasRequested,
    setRequestWasHandled,
    selectedVideoId,
    selectedQuizId,
    lessons,
    setCourseProgress,
    setExerciseWasRequested,
    setExerciseWasFetched,
    setSelectedEpisodeNumber,
    setSelectedExerciseIndex,
    setCurrPositionIndex,
  } = React.useContext(DataContext);

  const { token } = React.useContext(UserContext);

  const lessonDetail = lessons.find(
    (lesson) => lesson.episode_number === item.episode_number
  );

  const handleManuallyCompleteClick = () => {
    // (1.) update courseProgress locally
    const newStatus = item.status === 'INCOMPLETE' ? 'COMPLETE' : 'INCOMPLETE';
    setCourseProgress((oldCourseProgress) => {
      const newCourseProgress = { ...oldCourseProgress };
      const newSection = newCourseProgress[sectionLookup];
      const lessonIndex = newSection.findIndex(
        (lesson) => lesson.episode_number === item.episode_number
      );
      if (lessonIndex !== -1) {
        const lesson = newSection[lessonIndex];
        newSection[lessonIndex] = {
          ...lesson,
          status: newStatus,
        };
      }
      return newCourseProgress;
    });

    updateLessonCompleteEndpoint(
      selectedCourse,
      sectionLookup,
      item.episode_number,
      newStatus,
      token
    );
  };

  const handleClick = () => {
    if (lessonDetail.episode_id) {
      setSelectedVideoId(lessonDetail.episode_id);
      setSelectedEpisodeNumber(lessonDetail.episode_number);
      setSelectedQuizId('');
      setApiWasRequested(true);
      setRequestWasHandled(false);
      setSelectedExerciseIndex(0);
      setCurrPositionIndex(0);
    } else {
      setSelectedQuizId(lessonDetail.episode_number);
      setSelectedVideoId('');
      setSelectedEpisodeNumber('');
      setSelectedExerciseIndex(0);
      setCurrPositionIndex(0);
      setExerciseWasRequested(true);
      setExerciseWasFetched(false);
    }
  };
  const randomSVG = item.status === 'COMPLETE' ? cmCheckSVG : cmUncheckSVG;
  const svgPlusContainer = (
    <SVGMarginContainer>
      <button onClick={handleManuallyCompleteClick}>{randomSVG}</button>
    </SVGMarginContainer>
  );
  var progressIcon = svgPlusContainer;
  if (!lessonDetail.episode_id) {
    progressIcon = (
      <IconButton onClick={handleManuallyCompleteClick}>
        <img
          src={lessonDetail.title === 'Quiz' ? quizIcon : trainingIcon}
          alt='Quiz Icon'
          style={{ width: '24px', height: '28px' }}
        />
      </IconButton>
    );
  }

  const durationValue =
    lessonDetail.duration && lessonDetail.duration !== 'N/A'
      ? lessonDetail.duration
      : '';

  return (
    <Item selected={selectedVideoId || selectedQuizId} item={lessonDetail}>
      <Container>
        {progressIcon}
        <button onClick={handleClick}>
          {lessonDetail.title || 'No Title'}
        </button>
      </Container>
      <span>{durationValue}</span>
    </Item>
  );
}

export default Lesson;

const IconButton = styled.button`
  margin-right: 10px;
  margin-left: -5px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Item = styled.div`
  padding: 10px;
  padding-left: 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  &:last-of-type {
    padding-bottom: 24px;
  }
  background-color: ${({ selected, item }) =>
    selected === item.episode_id || selected === item.episode_number
      ? '#262626'
      : 'transparent'};
  border-left: ${({ selected, item }) =>
    selected === item.episode_id || selected === item.episode_number
      ? '3px solid #F57C00'
      : ''};
`;

const SVGMarginContainer = styled.span`
  margin-right: 10px;
  transform: translateY(1px);
  width: 18px;
  height: 18px;
  border: 2px solid white;
  border-radius: 2px;
  /* padding-left: 4px; */
`;

const cmCheckSVG = (
  <svg
    width='12px'
    height='9px'
    viewBox='0 0 12 9'
    stroke='white'
    strokeWidth='2'
    style={{ transform: 'translate(2px, 0px)' }}
  >
    <polyline points='1 5 4 8 11 1'></polyline>
  </svg>
);

const cmUncheckSVG = (
  <svg
    width='12px'
    height='9px'
    viewBox='0 0 12 9'
    stroke='transparent'
    strokeWidth='2'
    style={{ transform: 'translate(2px, 0px)' }}
    fill='transparent'
  >
    <polyline points='1 5 4 8 11 1'></polyline>
  </svg>
);

const squareSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-square'
    style={{ display: 'inline' }}
  >
    <rect width='18' height='18' x='3' y='3' rx='2' />
  </svg>
);

const checkboxSVG = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-square-check-big'
    style={{ display: 'inline' }}
  >
    <path d='M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5' />
    <path d='m9 11 3 3L22 4' />
  </svg>
);
